<template>
  <page-content
    :size="size"
    bg-shade
    no-top-content
    :stable-scrollbar-gutter="withScrollOffset"
  >
    <div class="compose__content">
      <details-hero
        :icon="iconsMap[view]"
        :title="title"
        :infos="infos"
        :override-details-hero-center-align-items="overrideDetailsHeroCenterAlignItems"
      >
        <div
          v-if="$slots['details-hero-info']"
          class="mr-4"
        >
          <slot name="details-hero-info" />
        </div>

        <template v-slot:right-content>
          <template v-if="!isMobile">
            <compose-toggle
              :value="view"
              button-height="26px"
              :class="rightContentMarginTopClass"
            />
          </template>
          <tm-icon-button
            icon-name="settings"
            icon-only
            variant="ghost"
            size="xMedium"
            class="ml-2"
            :class="rightContentMarginTopClass"
            :to="settingsRoute"
          />
        </template>

        <template
          v-if="isMobile"
          v-slot:bottom-left
        >
          <div class="w100pr">
            <compose-toggle
              class="compose__toggle-mobile"
              :value="view"
              spread
            />
          </div>
        </template>
      </details-hero>

      <slot />
    </div>
  </page-content>
</template>

<script setup lang="ts">
import type { IconName } from '@/assets/icons/icons'

import type { DetailsHeroInfo } from '@/components/shared/templates/details/type'
import type { PageContentMainSize } from '@/components/layout/pageContent/PageContentMain.vue'
import PageContent from '@/components/layout/pageContent/PageContent.vue'
import DetailsHero from '@/components/shared/templates/details/DetailsHero.vue'
import ComposeToggle from '@/components/domain/compose/ComposeToggle.vue'
import TmIconButton from '@/components/shared/TmIconButton.vue'
import { UserSettingsRoutes } from '@/routes/user/settings'
import { useBreakpoints } from '@/composition/breakpoints'
import { computed } from '@/composition/vue/compositionApi'
import type { ComposeToggleValue } from '@/services/domain/compose/types'
import { useRoutePrefetch } from '@/composition/useRoutePrefetch'

const { view, withScrollOffset, isDetailsHeroAlignItemsFlexStart } = defineProps<{
  view: ComposeToggleValue
  title: string
  infos?: DetailsHeroInfo[]
  size?: PageContentMainSize
  withScrollOffset?: boolean
  isDetailsHeroAlignItemsFlexStart?: boolean
}>()

const { isMobile } = useBreakpoints()

const iconsMap: Record<ComposeToggleValue, IconName> = {
  sms: 'chat',
  email: 'email',
}

const overrideDetailsHeroCenterAlignItems = computed(() => {
  if (!isDetailsHeroAlignItemsFlexStart) {
    return undefined
  }
  return 'flex-start'
})

const rightContentMarginTopClass = computed(() => {
  return isDetailsHeroAlignItemsFlexStart ? 'mt-2' : ''
})

const settingsRoute = computed(() => {
  return {
    name: view === 'sms' ? UserSettingsRoutes.SmsVoiceIndex : UserSettingsRoutes.Email,
  }
})

useRoutePrefetch([UserSettingsRoutes.SmsVoiceIndex, UserSettingsRoutes.Email])
</script>
<style lang="scss" scoped>
.compose {
  &__toggle-mobile {
    width: 100%;
    margin-top: 8px;
    box-sizing: border-box;
  }
}
</style>
